import emptySplitApi from "../utils/rtk";
import { CommonBody, MonthlyData } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
  file_url?: string;
};

export const analyticsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postUserGraph: builder.mutation<
      CommonResponseType & { data: MonthlyData },
      { id: number | null; body: CommonBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.userGraph}${id}/`,
        method: "POST",
        body,
      }),
    }),

    postApplicationGraph: builder.mutation<
      CommonResponseType & { data: MonthlyData },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.applicationGraph}`,
        method: "POST",
        body,
      }),
    }),

    postRevenueGraph: builder.mutation<
      CommonResponseType & { data: MonthlyData },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.revenueGraph}`,
        method: "POST",
        body,
      }),
    }),

    postUserExportCSV: builder.mutation<
      CommonResponseType & { data: MonthlyData },
      { id: number | null; body: CommonBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.userExportCSV}${id}/`,
        method: "POST",
        body,
      }),
    }),

    postApplicationExportCSV: builder.mutation<
      CommonResponseType & { data: MonthlyData },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.applicationExportCSV}`,
        method: "POST",
        body,
      }),
    }),

    postRevenueExportCSV: builder.mutation<
      CommonResponseType & { data: MonthlyData },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.revenueExportCSV}`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  usePostUserGraphMutation,
  usePostApplicationGraphMutation,
  usePostUserExportCSVMutation,
  usePostApplicationExportCSVMutation,
  usePostRevenueExportCSVMutation,
  usePostRevenueGraphMutation,
} = analyticsApi;
